export const TOP_PROGRESS_BAR_TEST_ID = 'topProgressBarTestId';

export const PROGRESSES_INITIAL_STATE = [];

export const MINIMUM_PROGRESS_VALUE = 0;
export const MAXIMUM_PROGRESS_VALUE = 100;
export const PROGRESS_SPEED = 0.1;
export const MOVE_INTERVAL_MS = 300;
export const ANIMATION_TIME_MS = 400; //must be in sync with css animation time

export enum ProgressActionType {
	AddProgress = 'addProgress',
	RemoveProgress = 'removeProgress',
	RemoveAllProgresses = 'removeAllProgresses',
	SetProgressValue = 'setProgressValue',
	SetAllProgressValues = 'setAllProgressValues',
	MakeProgressActive = 'activateProgress',
}

export const WRONG_ID_PARAM_IN_FINISH_ALERT_MESSAGE = `Please, provide 'id' param for 'finish' function of useTopProgressBarProvider.
	Or consider using 'finishAll' method.`;

export const WRONG_ID_PARAM_IN_RESET_ALERT_MESSAGE = `Please, provide 'id' param for 'reset' function of useTopProgressBarProvider.
	Or consider using 'resetAll' method.`;
